{
  "filter.queue": "na fila",
  "filter.progress": "em andamento",
  "filter.late": "com atraso",
  "filter.finished": "finalizados"
}
